import { useQuery } from '@tanstack/react-query'

import type { Entity } from '@models/Entity'

import { useAuthenticatedUser } from '../../../auth/hooks/useAuthenticatedUser'
import {
  fetchBijlageTemplatesForEntity,
  initialState,
} from '../services/fetchBijlageTemplatesForEntity'

export { useBijlageTemplatesForEntity }

const queryKey = 'entity-bijlage-templates'

const useBijlageTemplatesForEntity = (entity: Entity) => {
  const { hasPermissions } = useAuthenticatedUser()

  const { data } = useQuery({
    queryFn: () => fetchBijlageTemplatesForEntity(entity),
    queryKey: [queryKey, entity],
    enabled: hasPermissions && !!entity.id,
  })

  return {
    data: data || initialState.data,
  }
}
